import { flux } from '@/core/flux.module';
import type { AIPayload, Search } from '@/itemFinder/itemFinder.constants';
import type { UpdateSearchPayload } from '@/itemFinder/itemFinder.store';

export function setName(name: string) {
  flux.dispatch('ITEM_FINDER_SET_NAME', { name });
}

export function setCronSchedule(cronSchedule: string[]) {
  flux.dispatch('ITEM_FINDER_SET_CRON_SCHEDULE', { cronSchedule });
}

export function setTimezone(timezone: string | undefined) {
  flux.dispatch('ITEM_FINDER_SET_TIMEZONE', { timezone });
}

export function addSearch() {
  flux.dispatch('ITEM_FINDER_ADD_SEARCH');
}

export function removeSearch(index: number) {
  flux.dispatch('ITEM_FINDER_REMOVE_SEARCH', index);
}

export function updateSearch(payload: UpdateSearchPayload) {
  flux.dispatch('ITEM_FINDER_UPDATE_SEARCH', payload);
}

export function resetItemFinder() {
  flux.dispatch('RESET_ITEM_FINDER', {});
}

export function setItemFinder({
  value: { id, name, searches, cronSchedule, timezone, isVantage },
}: {
  value: {
    id: string;
    name: string;
    searches: Search[] | undefined;
    cronSchedule: string[] | undefined;
    timezone?: string;
    isVantage: boolean;
  };
}) {
  flux.dispatch('SET_EXISTING_ITEM_FINDER', { value: { id, name, searches, cronSchedule, timezone, isVantage } });
}

export function setPotentialSearchesPayload(payload: AIPayload) {
  if (payload.propertySearches) {
    payload.propertySearches.forEach((propertySearch) => {
      flux.dispatch('ITEM_FINDER_ADD_PROPERTY_SEARCH', propertySearch);
    });
  }
  if (payload.fixedListSearches) {
    payload.fixedListSearches.forEach((propertySearch) => {
      flux.dispatch('ITEM_FINDER_ADD_FIXED_LIST_SEARCH', propertySearch);
    });
  }
}
